import { useSearchParams } from 'react-router-dom';
import { useGetLagnaLordsQuery } from '@/store/api/lagnaLordsApi';
import Loader from '@/components/Loader';

export default function LagnaLords() {
  const [params] = useSearchParams();
  const userId = params.get('userId');

  const { data, isLoading, isError } = useGetLagnaLordsQuery(userId, {
    skip: !userId,
  });

  if (isError) {
    return <p className="p-6 text-center text-red-500">Failed to load Lagna Lords data</p>;
  }

  return (
    <div className="">
      <h3 className="font-32 font-semibold font-spectral mb-6 bg-clip-text text-transparent bg-gradient-to-r from-[#082261] to-[#34065c] text-center heading-uppercase">
        PLANETARY LORDSHIPS — LAGNA ({data?.lagna})
      </h3>

      <div className="overflow-x-auto">
        {isLoading ? (
          <Loader />
        ) : (
          <table className="min-w-full mt-2 border-collapse border border-[#2DAAFD] font-18 table-fixed whitespace-nowrap">
            <thead className="bg-[#001B6B] text-white font-spectral uppercase">
              <tr>
                <th className="border px-3 py-2 w-1/2">Planet</th>
                <th className="border px-3 py-2 w-1/2">Lordship of Houses</th>
              </tr>
            </thead>

            <tbody>
              {(data?.lords ?? []).map((row: any, i: number) => (
                <tr
                  key={i}
                  className={
                    i % 2 === 0 ? 'bg-white' : 'bg-[linear-gradient(to_right,#B7E2FF,#2DAAFD)]'
                  }
                >
                  <td className="border px-3 py-2 text-center border-black">{row.planet}</td>
                  <td className="border px-3 py-2 text-center border-black">
                    {row.loardShipHouse}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
